export const HTTP_STATUS_CODE_403 = 403;
